import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone, Mail, MapPin, Clock } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await axios.post(`${API_URL}/api/newsletter`, { email });
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    } catch {
      setSubscribed(true);
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  const productLinks = [
    { name: 'Trophies', path: '/products' },
    { name: 'Plaques', path: '/products' },
    { name: 'Crystal Awards', path: '/products' },
    { name: 'Medals', path: '/products' },
    { name: 'Name Badges', path: '/products' },
  ];

  const serviceLinks = [
    { name: 'Custom Engraving', path: '/services' },
    { name: 'Embroidery', path: '/services' },
    { name: 'Promotional Products', path: '/services' },
    { name: 'Rush Services', path: '/services' },
  ];

  const companyLinks = [
    { name: 'About Us', path: '/about' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Reviews', path: '/reviews' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' },
  ];

  // Social & Business Profile Links for SEO backlinks
  const socialLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/people/RC-Awards/100068143726981/',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      )
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/rcawardsllc/',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      )
    },
    {
      name: 'Yelp',
      url: 'https://www.yelp.com/biz/rc-awards-san-diego',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.16 12.594l-4.995 1.433c-.96.276-1.74-.8-1.176-1.63l2.905-4.308a1.072 1.072 0 0 1 1.596-.206 9.194 9.194 0 0 1 2.364 3.252 1.073 1.073 0 0 1-.694 1.459zm-3.753 5.472l-4.106-3.064c-.784-.584-.392-1.812.594-1.86l5.08-.244a1.074 1.074 0 0 1 1.078.858 9.195 9.195 0 0 1-.398 3.993 1.07 1.07 0 0 1-1.556.596l-.692-.28zm-6.282-.88l.988-5.14c.19-.99 1.47-1.2 1.936-.318l2.395 4.542c.306.58-.07 1.29-.73 1.378a9.2 9.2 0 0 1-3.947-.496 1.073 1.073 0 0 1-.642-1.966zm-2.07-5.576c.063-1.012 1.283-1.433 1.848-.64l2.91 4.09c.466.656-.082 1.54-.83 1.34l-4.86-1.303a1.072 1.072 0 0 1-.772-1.195c.168-1.12.51-2.2 1.003-3.192a1.072 1.072 0 0 1 .7-.6v-.5zm1.926-5.39l1.847 4.78c.358.924-.592 1.822-1.44 1.36L5.42 10.002a1.073 1.073 0 0 1-.46-1.468A9.2 9.2 0 0 1 7.7 5.71a1.072 1.072 0 0 1 1.581.51z"/>
        </svg>
      )
    },
    {
      name: 'Google Maps',
      url: 'https://www.google.com/maps/place/RC+Awards/@32.7548,-117.13735,17z/data=!4m8!3m7!1s0x80d954d3a5d9b36d:0x2ae1885968717e70',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 0C7.802 0 4 3.403 4 7.602 4 11.8 7.469 16.812 12 24c4.531-7.188 8-12.2 8-16.398C20 3.403 16.199 0 12 0zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
        </svg>
      )
    },
    {
      name: 'Apple Maps',
      url: 'https://maps.apple.com/place?map=explore&place-id=IE94584FDF37A3BCF&address=2509+El+Cajon+Blvd%2C+San+Diego%2C+CA++92104%2C+United+States&coordinate=32.754847%2C-117.137303&name=RC+Awards&_provider=9902',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
        </svg>
      )
    },
    {
      name: 'ZoomInfo',
      url: 'https://www.zoominfo.com/c/rc-awards/397896893',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14H6v-2h6v2zm4-4H6v-2h10v2zm0-4H6V7h10v2z"/>
        </svg>
      )
    }
  ];

  return (
    <footer data-testid="main-footer" className="bg-[#1a365d] text-white">
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_hospitality-hub-303/artifacts/55gdqw83_RC%20awards%20new%20logo%20-2.png" 
                alt="RC Awards & Promotions" 
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-sm text-white/70 mb-6 leading-relaxed">
              San Diego's premier source for custom trophies, awards, plaques, and promotional products. Quality craftsmanship since 1995.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3">
              <a href="tel:6196401633" className="flex items-center gap-2 text-sm text-white/70 hover:text-[#D4AF37] transition-colors">
                <Phone size={14} />
                (619) 640-1633
              </a>
              <a href="mailto:RCAwards@Aol.com" className="flex items-center gap-2 text-sm text-white/70 hover:text-[#D4AF37] transition-colors">
                <Mail size={14} />
                RCAwards@Aol.com
              </a>
              <a 
                href="https://www.google.com/maps/place/RC+Awards/@32.7548,-117.13735,17z"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-2 text-sm text-white/70 hover:text-[#D4AF37] transition-colors"
              >
                <MapPin size={14} className="flex-shrink-0 mt-0.5" />
                2509 El Cajon Blvd, San Diego, CA 92104
              </a>
            </div>
          </div>

          {/* Products Column */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Products</h4>
            <ul className="space-y-2">
              {productLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/70 hover:text-[#D4AF37] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="https://www.rcawards.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-[#D4AF37] hover:text-[#e5c04a] transition-colors font-medium"
                >
                  Shop All Products →
                </a>
              </li>
            </ul>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Services</h4>
            <ul className="space-y-2">
              {serviceLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/70 hover:text-[#D4AF37] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
            
            <h4 className="text-sm font-semibold text-white mb-4 mt-6 uppercase tracking-wider">Company</h4>
            <ul className="space-y-2">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/70 hover:text-[#D4AF37] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter & Hours Column */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Stay Updated</h4>
            <p className="text-sm text-white/70 mb-4">Subscribe for exclusive offers and product updates.</p>
            <form data-testid="footer-newsletter-form" onSubmit={handleNewsletterSubmit} className="flex items-center gap-2 mb-8">
              <input
                type="email"
                data-testid="footer-newsletter-input"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="flex-1 px-4 py-2.5 rounded-full border border-white/20 bg-white/10 text-sm text-white placeholder-white/50 focus:outline-none focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37]/20"
              />
              <button
                type="submit"
                data-testid="footer-newsletter-submit"
                className="bg-[#D4AF37] text-[#1a365d] p-2.5 rounded-full hover:bg-[#c9a432] transition-colors flex-shrink-0"
              >
                {subscribed ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                ) : (
                  <ArrowRight size={18} />
                )}
              </button>
            </form>

            {/* Business Hours */}
            <h4 className="text-sm font-semibold text-white mb-3 uppercase tracking-wider flex items-center gap-2">
              <Clock size={14} />
              Business Hours
            </h4>
            <div className="space-y-1 text-sm text-white/70">
              <p>Mon - Fri: 9:00 AM - 6:00 PM</p>
              <p>Saturday: 10:00 AM - 1:00 PM</p>
              <p>Sunday: Closed</p>
            </div>
          </div>
        </div>
      </div>

      {/* Social Links & Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-6 py-6">
          {/* Social Media Links - SEO Backlinks */}
          <div className="flex flex-wrap items-center justify-center gap-3 mb-6">
            <span className="text-xs text-white/50 mr-2">Find Us On:</span>
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-${social.name.toLowerCase().replace(' ', '-')}`}
                title={`RC Awards on ${social.name}`}
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white/70 hover:bg-[#D4AF37] hover:text-[#1a365d] transition-all duration-300"
              >
                {social.icon}
              </a>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/50">
              &copy; {new Date().getFullYear()} RC Awards & Promotions. All rights reserved. | San Diego, CA
            </p>
            <div className="flex items-center gap-4 text-xs text-white/50">
              <a
                href="https://www.rcawards.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#D4AF37] transition-colors"
              >
                Shop Online
              </a>
              <span>|</span>
              <Link to="/contact" className="hover:text-[#D4AF37] transition-colors">
                Contact Us
              </Link>
              <span>|</span>
              <Link to="/admin/login" className="hover:text-[#D4AF37] transition-colors">
                Admin
              </Link>
            </div>
          </div>

          {/* WebnehTech Credit */}
          <div className="mt-4 pt-4 border-t border-white/10 text-center">
            <p className="text-xs text-white/40">
              Website and SEO built and managed by{' '}
              <a
                href="https://webnehtech.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#D4AF37]/70 hover:text-[#D4AF37] transition-colors"
              >
                WebnehTech.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
